// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2zy_4","leftMenu":"_3xRR-","content":"AyXbz"};